import ReactDOM from 'react-dom';

export const Overlay = props =>
  ReactDOM.createPortal(props.children, document.getElementById('overlay'));
